'use client';

import config from '@/config';
import { ArrowRight } from 'lucide-react';
import mixpanel from 'mixpanel-browser';
import BusinessGameBoard from './BusinessGameBoard';

const tryFreeHref = `${config.appUrl}/register?corporate=true`;

export default function BusinessHero() {
  return (
    <section className="relative overflow-hidden bg-ink-900 text-paper-50">
      {/* Subtle dotted texture */}
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle at 1px 1px, #FDFAF3 1px, transparent 0)',
          backgroundSize: '22px 22px',
        }}
      />

      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-8 pt-16 lg:pt-24 pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left: headline + CTAs */}
          <div className="lg:col-span-7">
            <p className="font-display uppercase tracking-[0.18em] text-brand-300 text-sm mb-6">
              For L&amp;D, HR &amp; Ops
            </p>

            <h1 className="font-display font-black text-5xl md:text-6xl lg:text-[3.75rem] xl:text-[5.5rem] tracking-[-0.025em] leading-[0.95]">
              Training your team
              <br />
              will{' '}
              <span className="italic font-medium text-brand-300">
                actually
              </span>
              <br />
              finish.
            </h1>

            <div className="mt-8 max-w-xl border-l-2 border-brand-300 pl-5">
              <p className="font-display text-lg lg:text-xl text-paper-50/85 leading-relaxed">
                Game-based learning that turns onboarding, compliance, and
                product training into something employees complete, and
                remember.
              </p>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <a
                className="btn btn-primary btn-lg rounded-full px-8 text-white shrink-button btn-letterpress"
                href={config.bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  mixpanel.track('business_book_demo_clicked', {
                    location: 'hero',
                  })
                }
              >
                Book a demo
                <ArrowRight className="w-5 h-5" />
              </a>
              <a
                className="btn btn-ghost btn-lg rounded-full px-8 text-paper-50 border-2 border-paper-50/80 hover:bg-paper-50 hover:text-ink-900 transition-colors"
                href={tryFreeHref}
                onClick={() =>
                  mixpanel.track('business_try_free_clicked', {
                    location: 'hero',
                  })
                }
              >
                Try it free
              </a>
            </div>

            <p className="font-display text-paper-50/55 text-sm mt-5">
              30-minute call &middot; pricing tailored to team size &middot; no
              credit card to try
            </p>
          </div>

          {/* Right: live game-board screenshot mock */}
          <div className="lg:col-span-5">
            <BusinessGameBoard />
          </div>
        </div>

      </div>
    </section>
  );
}
